/**
 * The short, human reference for a support ticket - "#3EC9080E".
 *
 * Ticket ids are UUIDs. The list showed the first eight characters while the
 * detail page padded the whole UUID, so the breadcrumb and header printed all
 * 36 characters of it. One helper, used by both.
 */
export const ticketRef = (id: unknown): string => `#${String(id ?? '').substring(0, 8).toUpperCase()}`;
